import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { ObtenerUsuarioPorCargo, ObtenerUsuarioPorCargoInput } from '../entidades/entidades';
import Utils from "../shared/utilerias/utils";

@Injectable({
  providedIn: "root"
})
export class ObtenerUsuarioPorCargoService {
  private actionUrl: string;
  private actionUrlBusquedas: string;
  private headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.actionUrl = Utils.getBaseUrlApiWeb() + "/ObtenerUsuarioPorCargo/";
    this.actionUrlBusquedas = Utils.getBaseUrlApiWeb() + "/ObtenerUsuarioPorCargoBusquedas/";
    this.headers = new HttpHeaders();
    this.headers = this.headers.set("Content-Type", "application/json");
    this.headers = this.headers.set("Accept", "application/json");
  }

  getBusquedas(obtenerUsuarioPorCargo: ObtenerUsuarioPorCargoInput): Observable<ObtenerUsuarioPorCargo[]> {
    return this.http
      .post<ObtenerUsuarioPorCargo[]>(this.actionUrl, obtenerUsuarioPorCargo, {
        headers: this.headers
      })
      .pipe(catchError(this.handleError));
  }
  getAll(): Observable<ObtenerUsuarioPorCargo[]> {
    return this.http
      .get<ObtenerUsuarioPorCargo[]>(this.actionUrl, { headers: this.headers })
      .pipe(
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getSingle(id: number): Observable<ObtenerUsuarioPorCargo> {
    return this.http
      .get<ObtenerUsuarioPorCargo>(this.actionUrl + id, { headers: this.headers })
      .pipe(
        tap(data => data),
        catchError(this.handleError)
      );
  }

  add(obtenerUsuarioPorCargo: ObtenerUsuarioPorCargoInput) {
    return this.http
      .post<ObtenerUsuarioPorCargo>(this.actionUrl, obtenerUsuarioPorCargo, {
        headers: this.headers
      })
      .pipe(catchError(this.handleError));
  }
  update(obtenerUsuarioPorCargo: ObtenerUsuarioPorCargo) {
    return this.http
      .put<ObtenerUsuarioPorCargo>(
        this.actionUrl + obtenerUsuarioPorCargo.id,
        JSON.stringify(obtenerUsuarioPorCargo),
        {
          headers: this.headers
        }
      )
      .pipe(catchError(this.handleError));
  }

  delete(id: number) {
    return this.http
      .delete<ObtenerUsuarioPorCargo>(this.actionUrl + id, {
        headers: this.headers
      })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error("An error occurred:", error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    return throwError("Something bad happened; please try again later.");
  }
}